import { render, staticRenderFns } from "./MainChartsController.vue?vue&type=template&id=0666d05d&scoped=true&"
import script from "./MainChartsController.vue?vue&type=script&lang=js&"
export * from "./MainChartsController.vue?vue&type=script&lang=js&"
import style0 from "./MainChartsController.vue?vue&type=style&index=0&id=0666d05d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0666d05d",
  null
  
)

export default component.exports